import { FactAdder } from '@/new/components/fact-adder';
import { Icon } from '@/new/components/icon';
import { Button } from '@/new/components/shadcn/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/new/components/shadcn/dialog';
import { DocIds } from '@/types';

interface AddFactDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  caseId: string;
  docs: DocIds[];
  handleNewFactCreated: () => void;
}

export const AddFactDialog = ({ isOpen, onOpenChange, caseId, docs, handleNewFactCreated }: AddFactDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogTrigger asChild>
        <Button>
          <Icon className="lucide--plus-circle" />
          Add Fact
        </Button>
      </DialogTrigger>

      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>
            <Icon className="lucide--filter" />
            Add Fact
          </DialogTitle>
        </DialogHeader>

        <FactAdder caseId={caseId} docs={docs} handleNewFactCreated={handleNewFactCreated} />
      </DialogContent>
    </Dialog>
  );
};
